// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fadein {
  animation: fadein 0.3s;
}

.fadeout {
  animation: fadeout 0.3s;
}

@keyframes fadein {
  from {
    opacity: 0;
    transform: translate3d(0, -0.5rem, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.toast-action-button {
  max-width: 10rem !important;
}

.processing-fadein {
  animation: fadein 1s;
}

.processing-fadeout {
  animation: fadeout 0.5s;
  display: none !important;
}

.spreadsheet--validating {
  -ms-grid-columns: auto 1fr;
  background: whitesmoke;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 1px 20px rgba(0, 0, 0, 0.3);
  display: grid;
  font-size: 1rem;
  grid-template-columns: auto 1fr;
  height: 30px;
  left: calc(50% - 100px);
  line-height: 1.8rem;
  padding: 20px;
  position: absolute;
  text-align: center;
  top: calc(50% - 100px);
  -webkit-user-select: none;
          user-select: none;
  width: 200px;
  z-index: 9999 !important;
}

gc-spread-sheets .gc-popup.ui-widget.gc-smart-tag-default {
  display: none !important;
}

#balance-sheet-structure [gcuielement=gcValidationSelect] {
  position: fixed !important;
}`, "",{"version":3,"sources":["webpack://./src/app/styles/base/common/_animations.scss","webpack://./src/app/components/model-structure/balance-sheet/input-structure/input-structure.component.scss"],"names":[],"mappings":"AA6CA;EACE,sBAAA;AC5CF;;AD8CA;EACE,uBAAA;AC3CF;;AD8CA;EACE;IACE,UAAA;IACA,qCAAA;EC3CF;ED6CA;IACE,UAAA;IACA,+BAAA;EC3CF;AACF;AD6CA;EACE;IACE,UAAA;EC3CF;ED6CA;IACE,UAAA;EC3CF;AACF;AAvBA;EACE,2BAAA;AAyBF;;AAtBA;EACE,oBAAA;AAyBF;;AAvBA;EACE,uBAAA;EACA,wBAAA;AA0BF;;AAvBA;EAEE,0BAAA;EACA,sBAAA;EACA,uEAAA;EAEA,aAAA;EACA,eAAA;EACA,+BAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,YAAA;EACA,wBAAA;AAyBF;;AArBE;EAEE,wBAAA;AAuBJ;;AAlBE;EACE,0BAAA;AAqBJ","sourcesContent":["// // Common properties\r\n// .animation {\r\n//   animation-duration: 1s;\r\n//   animation-fill-mode: forwards;\r\n//   animation-timing-function: ease-in-out;\r\n// }\r\n\r\n// // APPEAR\r\n\r\n// .appear {\r\n//   @extend .animation;\r\n//   height: 100%;\r\n//   animation-name: appearAnimation;\r\n// }\r\n\r\n// @keyframes appearAnimation {\r\n//   0% {\r\n//     height: 0%;\r\n//     // top: -100%;\r\n//   }\r\n//   100% {\r\n//     height: 100%;\r\n//     // top: 0;\r\n//   }\r\n// }\r\n\r\n// // DISAPPEAR\r\n\r\n// .disappear {\r\n//   @extend .animation;\r\n//   height: 0%;\r\n//   animation-name: disappearAnimation;\r\n// }\r\n\r\n// @keyframes disappearAnimation {\r\n//   0% {\r\n//     // top: 0;\r\n//     height: 100%;\r\n//   }\r\n//   100% {\r\n//     // top: -100%;\r\n//     height: 0;\r\n//   }\r\n// }\r\n\r\n.fadein {\r\n  animation: fadein 0.3s;\r\n}\r\n.fadeout {\r\n  animation: fadeout 0.3s;\r\n}\r\n\r\n@keyframes fadein {\r\n  from {\r\n    opacity: 0;\r\n    transform: translate3d(0, -0.5rem, 0);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translate3d(0, 0, 0);\r\n  }\r\n}\r\n@keyframes fadeout {\r\n  from {\r\n    opacity: 1;\r\n  }\r\n  to {\r\n    opacity: 0;\r\n  }\r\n}\r\n","@import '../../../../styles/base/common/animations';\r\n\r\n.toast-action-button {\r\n  max-width: 10rem !important;\r\n}\r\n\r\n.processing-fadein {\r\n  animation: fadein 1s;\r\n}\r\n.processing-fadeout {\r\n  animation: fadeout 0.5s;\r\n  display: none !important;\r\n}\r\n\r\n.spreadsheet--validating {\r\n  // animation: fadein 2s;\r\n  -ms-grid-columns: auto 1fr;\r\n  background: whitesmoke;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 1px 20px rgba(0, 0, 0, 0.3);\r\n  display: -ms-grid;\r\n  display: grid;\r\n  font-size: 1rem;\r\n  grid-template-columns: auto 1fr;\r\n  height: 30px;\r\n  left: calc(50% - 100px);\r\n  line-height: 1.8rem;\r\n  padding: 20px;\r\n  position: absolute;\r\n  text-align: center;\r\n  top: calc(50% - 100px);\r\n  user-select: none;\r\n  width: 200px;\r\n  z-index: 9999 !important;\r\n}\r\n\r\ngc-spread-sheets {\r\n  .gc-popup.ui-widget.gc-smart-tag-default {\r\n    // Hide context-menu for drag-and-fill\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n#balance-sheet-structure {\r\n  [gcuielement='gcValidationSelect'] {\r\n    position: fixed !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
